import { useEffect, useMemo, useState } from "react";
import { useSearchParams } from "react-router-dom";
import { api } from "../lib/api";
import { focusShared } from "../lib/deepLink";
import { PageHeader } from "../components/PageHeader";
import { Scale, Download, FileText } from "lucide-react";

export default function ProdukHukum() {
  const [docs, setDocs] = useState([]);
  const [cat, setCat] = useState("Semua");
  const [searchParams] = useSearchParams();

  useEffect(() => {
    api.get("/legal-docs").then((r) => {
      setDocs(r.data);
      const dokId = searchParams.get("dok");
      if (dokId) focusShared(`dok-${dokId}`);
    }).catch(() => {});
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const categories = useMemo(() => ["Semua", ...Array.from(new Set(docs.map((d) => d.category)))], [docs]);
  const filtered = cat === "Semua" ? docs : docs.filter((d) => d.category === cat);

  return (
    <div data-testid="produk-hukum-page">
      <PageHeader title="Produk Hukum" subtitle="Peraturan, keputusan, dan pedoman teknis penanggulangan bencana — dapat diunduh oleh masyarakat" />
      <section className="max-w-7xl mx-auto px-4 py-16">
        {docs.length > 0 && (
          <div className="flex flex-wrap gap-2 mb-10" data-testid="produk-hukum-filter">
            {categories.map((c) => (
              <button
                key={c}
                onClick={() => setCat(c)}
                className={`btn-pop px-5 py-2 rounded-full text-sm font-bold ${
                  cat === c ? "bg-orange-600 text-white" : "bg-white border border-slate-200 text-slate-600 hover:border-orange-400 hover:text-orange-600"
                }`}
                data-testid={`produk-filter-${c.toLowerCase().replace(/\s|\//g, "-")}`}
              >
                {c}
              </button>
            ))}
          </div>
        )}
        {filtered.length === 0 ? (
          <div className="border-2 border-dashed border-slate-200 rounded-xl p-16 text-center text-slate-400" data-testid="produk-hukum-empty">
            <Scale className="mx-auto mb-3" size={32} />
            Belum ada produk hukum yang dipublikasikan. Admin dapat menambahkannya melalui menu "Produk Hukum".
          </div>
        ) : (
          <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-5">
            {filtered.map((d) => (
              <div key={d.id} id={`dok-${d.id}`} className="hover-lift flex flex-col border border-slate-200 bg-white rounded-xl p-6" data-testid={`produk-item-${d.id}`}>
                <div className="flex items-start gap-3">
                  <div className="w-10 h-10 rounded-xl bg-orange-50 text-orange-600 flex items-center justify-center shrink-0">
                    <FileText size={19} />
                  </div>
                  <div className="min-w-0">
                    <div className="flex flex-wrap items-center gap-1.5 mb-1.5">
                      <span className="font-mono text-[10px] uppercase tracking-wider bg-orange-100 text-orange-700 px-2 py-0.5 rounded">{d.category}</span>
                      {d.year && <span className="font-mono text-[10px] bg-slate-100 text-slate-600 px-2 py-0.5 rounded">{d.year}</span>}
                    </div>
                    <h3 className="font-heading font-bold text-slate-900 leading-snug">{d.title}</h3>
                  </div>
                </div>
                {d.description && <p className="text-sm text-slate-500 mt-3 line-clamp-3">{d.description}</p>}
                <a
                  href={d.file_url}
                  target="_blank"
                  rel="noreferrer"
                  className="btn-pop mt-auto pt-4 inline-flex items-center gap-2 text-sm font-bold text-sky-600 hover:text-orange-600"
                  data-testid={`produk-download-${d.id}`}
                >
                  <Download size={15} /> Unduh Dokumen
                </a>
              </div>
            ))}
          </div>
        )}
      </section>
    </div>
  );
}
